import type {
  TGeneralToolkit,
  TGeneralToolkitSplitBahanAjar,
  TToolkitType,
  TToolkitTypeName,
  TToolkitTypeWithRpp,
} from 'types/toolkit'

export const GENERAL_TOOLKIT_TO_TOOLKIT_TYPE_MAPPING: Record<
  TGeneralToolkit,
  TToolkitType[]
> = {
  modul_bahan_ajar: ['modul-ajar-rpp', 'bahan-ajar'],
  buku: ['buku-guru', 'buku-murid'],
  modul_projek: ['modul-projek'],
}

export const GENERAL_TOOLKIT_SPLIT_BAHAN_AJAR_TO_TOOLKIT_TYPE_MAPPING: Record<
  TGeneralToolkitSplitBahanAjar,
  TToolkitTypeWithRpp[]
> = {
  modul_ajar: ['modul-ajar-rpp', 'rpp'],
  bahan_ajar: ['bahan-ajar'],
  buku: ['buku-guru', 'buku-murid'],
  modul_projek: ['modul-projek'],
}

export const TOOLKIT_TYPE_TO_GENERAL_TOOLKIT_MAPPING: Record<
  TToolkitType,
  TGeneralToolkit
> = {
  'modul-ajar-rpp': 'modul_bahan_ajar',
  'bahan-ajar': 'modul_bahan_ajar',
  'buku-guru': 'buku',
  'buku-murid': 'buku',
  'modul-projek': 'modul_projek',
}

export const TOOLKIT_TYPE_TO_GENERAL_TOOLKIT_SPLIT_BAHAN_AJAR_MAPPING: Record<
  TToolkitType,
  TGeneralToolkitSplitBahanAjar
> = {
  'modul-ajar-rpp': 'modul_ajar',
  'bahan-ajar': 'bahan_ajar',
  'buku-guru': 'buku',
  'buku-murid': 'buku',
  'modul-projek': 'modul_projek',
}

export const GENERAL_TOOLKIT_LIST: { label: string; name: TGeneralToolkit }[] =
  [
    {
      label: 'Modul & Bahan Ajar',
      name: 'modul_bahan_ajar',
    },
    {
      label: 'Buku',
      name: 'buku',
    },
    {
      label: 'Modul Projek',
      name: 'modul_projek',
    },
  ]

export const GENERAL_TOOLKIT_SPLIT_BAHAN_AJAR_LIST: {
  label: string
  name: TGeneralToolkitSplitBahanAjar
}[] = [
  {
    label: 'Modul Ajar & RPP',
    name: 'modul_ajar',
  },
  {
    label: 'Bahan Ajar',
    name: 'bahan_ajar',
  },
  {
    label: 'Buku',
    name: 'buku',
  },
  {
    label: 'Modul Projek',
    name: 'modul_projek',
  },
]

export const TOOLKIT_TYPE_TO_TOOLKIT_TYPE_NAME_MAPPING: Record<
  TToolkitType,
  TToolkitTypeName
> = {
  'modul-ajar-rpp': 'Modul Ajar',
  'bahan-ajar': 'Bahan Ajar',
  'buku-guru': 'Buku Guru',
  'buku-murid': 'Buku Murid',
  'modul-projek': 'Modul Projek',
}

export const TOOLKIT_TYPE_TO_TOOLKIT_TYPE_WITH_RPP_NAME_MAPPING: Record<
  TToolkitTypeWithRpp,
  TToolkitTypeName
> = {
  'modul-ajar-rpp': 'Modul Ajar',
  'bahan-ajar': 'Bahan Ajar',
  'buku-guru': 'Buku Guru',
  'buku-murid': 'Buku Murid',
  'modul-projek': 'Modul Projek',
  rpp: 'RPP',
}

export const TOOLKIT_BAHAN_AJAR_DISCOVERY_EXPERIMENT_KEY =
  'ab_test_toolkit_bahan_ajar_discovery_v1'
